import { React, useEffect } from 'react';
import { useState, useRef } from 'react';
import { styled } from '@mui/system';
import { Divider, Box } from '@mui/material';
import Loading from '../../../../components/ui/Loading';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';

import AutocompleteSearch from '../AutocompleteSearch/AutocompleteSearch';
import { useGetEightCafeInfoQuery } from '../../../../store/api/cafeApi';

const CafeContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  bottom: '0px',
  maxHeight: '200px',
});

const AddACafeButton = styled('button')({
  width: '100px',
  height: '30px',
  fontFamily: 'Fjalla One',
  fontStyle: 'normal',
  fontWeight: '400px',
  fontSize: '16px',
  lineHeight: '20px',
  color: '#FFFFFF',
  background: '#AA9178',
  border: 'none',
  borderRadius: '50px',
  marginTop: '-8px',
});

const CafeDisplayArea = styled('div')({
  marginTop: '8px',
  marginBottom: '7px',
  overflow: 'scroll',
  overflowX: 'hidden',
  height: '100px',
  width: '400px',
  '&::-webkit-scrollbar': { width: '0px' },
});

const NoteEditPageDivider = styled(Divider)(({ theme }) => ({
  width: '383px',
  borderBottom: '2px solid rgb(166,146,123)',
  marginBottom: '5px',
  marginTop: '-15px',
  [theme.breakpoints.down('md')]: {
    width: '350px',
  },
}));

const NoteEditPageBottomDivider = styled(Divider)(({ theme }) => ({
  width: '383px',
  borderBottom: '2px solid rgb(166,146,123)',
  marginTop: '134px',
  position: 'absolute',
  [theme.breakpoints.down('md')]: {
    width: '350px',
  },
}));

const ErrorMessage = styled('div')({
  fontSize: '12px',
  color: 'red',
  height: '18px',
  marginTop: '8px',
});

const ErrorMessageEmpty = styled('div')({
  height: '18px',
});

const DialogBox = styled('div')({
  width: '350px',
  height: '550px',
  overflow: 'hidden',
  padding: '14px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#FEFEFE',
  boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.3)',
});

const InnerYellowFrame = styled(Box)({
  width: '320px',
  height: '530px',
  padding: '15px',
  border: '1px solid #AA9178',
});

const CloseBtn = styled(IconButton)({
  marginTop: '24px',
  marginLeft: '295px',
  position: 'absolute',
  padding: '0',
  zIndex: '1',
});

const DialogTitle = styled('h4')({
  fontFamily: 'Fjalla One',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '20px',
  lineHeight: '25px',
  color: '#000000',
  textTransform: 'capitalize',
  padding: '0',
  margin: '0 0 23px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '-5px',
});

const Diamond = styled('div')({
  width: '80px',
  height: '8px',
  textAlign: 'center',
  position: 'relative',
  color: 'rgb(166,146,123)',
  fontSize: '8px',
  lineHeight: '10px',
  marginTop: '2px',
  '&:before,&:after': {
    content: '""',
    width: '35px',
    height: '2px',
    position: 'absolute',
    left: '0px',
    border: '1px solid',
    top: '65%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgb(166,146,123)',
  },
  '&:before': {},
  '&:after': {
    left: '45px',
    right: '0',
  },
});

const NoteEditAddOrRemoveCafe = ({ formik }) => {
  const [open, setOpen] = useState(false);
  const [cafe, setCafe] = useState(formik.values.relatedCafes);
  const [selectedItems, setSelectedItems] = useState([]);
  const [formikItems, setFormikItems] = useState([]);

  const [limit, setLimit] = useState(8);
  const [skip, setSkip] = useState(0);

  const { data: cafeInfo, isLoading } = useGetEightCafeInfoQuery({ limit, skip });
  if (isLoading) return <Loading />;
  if (!cafeInfo) return <Loading />;

  console.log(cafeInfo);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCafeSelect = (formikItems) => {
    const temp = formikItems.map((item) => item);
    formik.setFieldValue('relatedCafes', temp.length > 0 ? temp : []);
  };

  const handleCafeDelete = (cafeToDelete) => () => {
    const allCafes = formik.values.relatedCafes;
    const index2 = allCafes.findIndex((item) => item === cafeToDelete._id);

    const index = selectedItems.findIndex((item) => item._id === cafeToDelete._id);
    allCafes.splice(index2, 1);
    selectedItems.splice(index, 1);
    setCafe((cafes) => cafes.filter((cafe) => cafe._id !== cafeToDelete._id));
  };

  return (
    <CafeContainer>
      <NoteEditPageDivider />
      <CafeDisplayArea>
        {selectedItems.map((e) => {
          return (
            <Chip
              avatar={<Avatar alt="Cafe_picture" src={e.attachments[0]?.url} />}
              label={e.cafeName}
              onDelete={handleCafeDelete(e)}
              style={{
                background: 'none',
                border: '1px solid #AA9178',
                fontFamily: 'Fjalla One',
                fontStyle: 'normal',
                fontWeight: '400px',
                fontSize: '16px',
                lineHeight: '20px',
                marginRight: '5px',
                marginBottom: '5px',
              }}
              sx={{
                '& .MuiChip-deleteIcon': {
                  color: 'rgba(0, 0, 0, 0.54)',
                },
              }}
            />
          );
        })}
      </CafeDisplayArea>
      <>
        <AddACafeButton type="button" onClick={handleOpen}>
          Add a Cafe
        </AddACafeButton>
        <Dialog
          PaperProps={{ style: { borderRadius: 0 } }}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          open={open}
          onClose={handleClose}
          sx={{
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          <CloseBtn aria-label="close" onClick={() => handleClose()}>
            <CloseIcon />
          </CloseBtn>
          <DialogBox>
            <InnerYellowFrame>
              <DialogTitle id="scroll-dialog-title">
                Add Cafe
                <Diamond>♦</Diamond>
              </DialogTitle>

              <AutocompleteSearch
                items={cafeInfo}
                relatedCafeOnChange={handleCafeSelect}
                addedItems={selectedItems}
                setItems={setSelectedItems}
                addedFormikItems={formikItems}
                setTheFormikItems={setFormikItems}
                setSkipValue={setSkip}
              />
            </InnerYellowFrame>
          </DialogBox>
        </Dialog>
      </>

      <NoteEditPageBottomDivider />
      {formik.errors.relatedCafes && formik.touched.relatedCafes ? (
        <ErrorMessage>Please add at least one cafe</ErrorMessage>
      ) : (
        <ErrorMessageEmpty />
      )}
    </CafeContainer>
  );
};

export default NoteEditAddOrRemoveCafe;
